// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: #f3d7cc;
  text-decoration-style: dashed;
}

.side_images_grid {
  display: inline-flex;
  padding: 10px;
  overflow-x: scroll;
  width: 98%;
}

ul {
  list-style: none;
}

.indented {
  padding-left: 15px;
  box-sizing: border-box;
  background: #fff8ef !important;
}

.clear ion-item {
  opacity: 0.6 !important;
}

ion-item {
  --border-color: #f7f7f7;
  padding: 12px 0;
  background: rgba(112, 112, 112, 0) !important;
}

ion-select {
  width: 100%;
}

.form_content {
  background: #fff2e5;
}

.inline-price {
  margin-left: auto;
  width: 100%;
}
.inline-price label {
  position: absolute;
  margin-top: 9px;
  width: 10px;
  border-right: 2px solid rgba(173, 136, 117, 0.2705882353) !important;
  padding-right: 15px;
  padding-top: 5px;
  color: rgba(173, 136, 117, 0.5019607843);
}
.inline-price ion-input {
  margin-left: 30px;
  margin-top: 5px;
  text-align: left;
  width: 100%;
}

.tags {
  margin: 0;
  background: #fff8ef;
  width: 95%;
  padding: 20px;
  border-radius: 5px;
}
.tags .filled {
  background: #dbb49f;
  color: #fff;
  border: none;
}
.tags .unfilled {
  background: #fff !important;
  color: #dbb49f !important;
  border: 1px solid #dbb49f !important;
}

.desc_item ion-label {
  font-size: 18px;
}
.desc_item ion-textarea {
  font-size: 14px;
  margin-bottom: 200px;
}

.name_toolbar {
  text-align: center;
  font-size: 12px;
}

.no_messages {
  text-align: center;
}

.toolblue {
  text-align: center;
  color: #fff;
}

ion-spinner {
  margin-top: 40%;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.thin_item {
  padding: 0;
}
.thin_item ion-label {
  padding: 10px;
  border-radius: 6px;
  color: #ad8875;
  background: #fff2e5;
  border-bottom: 4px solid #ad8875 !important;
  font-family: monospace !important;
  text-decoration: none;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/listing-form/listing-form.page.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,6BAAA;AACJ;;AAEA;EACI,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,sBAAA;EACA,8BAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAEA;EACI,uBAAA;EAEA,eAAA;EACA,6CAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,WAAA;AAAJ;AAEI;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,oEAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;AAAR;AAGI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AADR;;AAKA;EACI,SAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;AAFJ;AAII;EACI,mBAAA;EACA,WAAA;EACA,YAAA;AAFR;AAKI;EACI,2BAAA;EACA,yBAAA;EACA,oCAAA;AAHR;;AAQI;EACI,eAAA;AALR;AAOI;EACI,eAAA;EACA,oBAAA;AALR;;AASA;EACI,kBAAA;EACA,eAAA;AANJ;;AASA;EACI,kBAAA;AANJ;;AASA;EACI,kBAAA;EACA,WAAA;AANJ;;AASA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AANJ;;AAUA;EACI,UAAA;AAPJ;AASI;EACI,aAAA;EACA,kBAAA;EAEA,cAAA;EACA,mBAAA;EACA,2CAAA;EAEA,iCAAA;EACA,qBAAA;EACA,eAAA;AATR","sourcesContent":["ion-label {\n    text-decoration: underline;\n    text-underline-offset: 3px;\n    text-decoration-color: #f3d7cc;\n    text-decoration-style: dashed;\n}\n\n.side_images_grid {\n    display: inline-flex;\n    padding: 10px;\n    overflow-x: scroll;\n    width: 98%;\n}\n\nul {\n    list-style: none;\n}\n\n.indented {\n    padding-left: 15px;\n    box-sizing: border-box;\n    background: #fff8ef !important;\n}\n\n.clear ion-item {\n    opacity: 0.6 !important;\n}\n\nion-item {\n    --border-color: #f7f7f7;\n\n    padding: 12px 0;\n    background: #70707000 !important;\n}\n\nion-select {\n    width: 100%;\n}\n\n.form_content {\n    background: #fff2e5;\n}\n\n.inline-price {\n    margin-left: auto;\n    width: 100%;\n\n    label {\n        position: absolute;\n        margin-top: 9px;\n        width: 10px;\n        border-right: 2px solid #ad887545 !important;\n        padding-right: 15px;\n        padding-top: 5px;\n        color: #ad887580;\n    }\n\n    ion-input {\n        margin-left: 30px;\n        margin-top: 5px;\n        text-align: left;\n        width: 100%;\n    }\n}\n\n.tags {\n    margin: 0;\n    background: #fff8ef;\n    width: 95%;\n    padding: 20px;\n    border-radius: 5px;\n\n    .filled {\n        background: #dbb49f;\n        color: #fff;\n        border: none;\n    }\n\n    .unfilled {\n        background: #fff !important;\n        color: #dbb49f !important;\n        border: 1px solid #dbb49f !important;\n    }\n}\n\n.desc_item {\n    ion-label {\n        font-size: 18px;\n    }\n    ion-textarea {\n        font-size: 14px;\n        margin-bottom: 200px;\n    }\n}\n\n.name_toolbar {\n    text-align: center;\n    font-size: 12px;\n}\n\n.no_messages {\n    text-align: center;\n}\n\n.toolblue {\n    text-align: center;\n    color: #fff;\n}\n\nion-spinner {\n    margin-top: 40%;\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n}\n\n\n.thin_item {\n    padding: 0;\n\n    ion-label {\n        padding: 10px;\n        border-radius: 6px;\n\n        color: #ad8875;\n        background: #fff2e5;\n        border-bottom: 4px solid #ad8875 !important;\n\n        font-family: monospace !important;\n        text-decoration: none;\n        font-size: 12px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
